// removed by extract-text-webpack-plugin
module.exports = {"background":"hover__background___1Vfco","color":"hover__color___VgG2E c-blue--hover fill-blue--hover"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-toolbar/ToolbarButton/style/hover.css
// module id = 256
// module chunks = 0 13